import React from 'react';
import styled from '@emotion/styled';
import { Button, Modal } from 'rsuite';
import { GeneratedDocument, GeneratedDocumentType } from '../../api/generateddocuments/generatedDocumentsApiTypes';

interface Props {
  open: boolean;
  onClose: () => void;
  onShowDocuments: () => void;
  document: GeneratedDocument;
}

const generatedDocumentTypeTitles: Record<GeneratedDocumentType, string> = {
  [GeneratedDocumentType.LISTING_REPORT_EXPORT]: 'Generate report',
};

const InlineLinkButton = styled(Button)`
    display: inline;
    padding: 0;
    vertical-align: baseline;
`;

function getTitle(type: GeneratedDocumentType): string {
  return generatedDocumentTypeTitles[type] || 'Generate document';
}

export default function GeneratedDocumentQueuedModal({
  open,
  onClose,
  onShowDocuments,
  document,
}: Props) {
  return (
    <Modal open={open} onClose={() => onClose()} size="xs">
      <Modal.Header>
        <Modal.Title>{getTitle(document.type)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Queued
          {' '}
          <strong>{document.title}</strong>
          .
        </p>
        <p>
          <InlineLinkButton appearance="link" onClick={() => onShowDocuments()}>
            Track its progress here.
          </InlineLinkButton>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => onClose()} appearance="primary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
